<template>
    <div>
        <TagSelector mainHeading="" optionName="skills" availableOptionsHeading="Activities/Events List"
            selectedOptionsHeading="User's Admin activities/events" :initial-skills="availableActivities"
            v-model:interests="userActivities" :on-save="handleSaveActivities" :loading="loading"
            :isSaving="activitiessubmitting" />
    </div>
</template>

<script setup>
import { onMounted, ref, inject } from "vue";
import { useStore } from "vuex";
import TagSelector from "@/components/common/TagSelector.vue";
import { getLocationId } from "../../../utils/SessionDataHandler";
import { useRoute } from "vue-router";

// store
const store = useStore();
const route = useRoute();
const loading = ref(false);
const activitiessubmitting = ref(false);

const _injectedPersonId = inject('editUserPersonId', null);
const personId = _injectedPersonId?.value || Number(route.params.userid);
const locationId = getLocationId();

// state
const availableActivities = ref([]);
const userActivities = ref([]);

const mapActivities = (list) =>
    (list || []).map((a) => ({
        id: a.skillid,
        name: a.skillname,
        description: a.description ?? "",
    }));


onMounted(async () => {
    // === Skills ===
    loading.value = true;
    try {
        const activitiesRes = await store.dispatch("fetchPersonSkillsModal", {
            locationId,
            personId,
        });
        availableActivities.value = mapActivities(activitiesRes.available_skills);
        userActivities.value = mapActivities(activitiesRes.current_skills);
    }
    finally {
        loading.value = false;
    }
});

// Handlers for saving
const handleSaveActivities = async (selected) => {
    console.log("selected", selected);

    activitiessubmitting.value = true;
    try {
        await store.dispatch("savePersonSkills", {
            personId,
            skillsArray: selected.map((x) => x.id),
        });
    }
    finally {
        activitiessubmitting.value = true;
    }
};

</script>